export interface IDownlineStats {
  level: number;
  registrations: number;
  pushNotifications: number;
  downloads: number;
  totalDeposits: number;
}

export interface IWallet {
  id: number;
  customerId: string;
  currency: string;
  groupId: number;
  platform: string;
  status: WalletStatus;
  leverage: number;
  type: string;
  isDemo: boolean;
  tradingType: TradingType;
  balance?: string;
  credit?: string;
  equity?: string;
  margin?: string;
  marginFree?: string;
  profitLoss?: string;
  marginLevelPercent?: number;
  group?: {
    name: string;
  };
  primary?: boolean;
}

export interface IMessage {
  id: string;
  createdAt: Date;
  updatedAt: Date;
  noRecipients: number;
  text: string;
  subject: string | null;
}

export interface ITargetGroup {
  id: string;
  name: string;
  noRecipients: { [method: string]: number };
}

export interface ILandingPage {
  preview: string;
  name: string;
  language: string | null;
  url: string;
}

export interface IDashboardChartDatum {
  date: Date;
  value: number;
}

export interface IDashboardReferral {
  name: string;
  id: string;
  country: string;
  lastSignInDate: string;
}

export interface IDashboardStats {
  signUpsLastMonth: number;
  signUpsThisMonth: number;
  earningsThisMonth: number;
  earningsLastMonth: number;
  cpasLastMonth: number;
  cpasThisMonth: number;
  volumesLastMonth: number;
  volumesThisMonth: number;
  totalBalance: number;
  unpaidBalance: number;
  totalLoginsLastMonth: number;
  totalLoginsThisMonth: number;
  last5SignIns: Array<IDashboardReferral>;
}

export enum UserRole {
  Admin = 'ADMIN',
  Trader = 'TRADER',
  Affiliate = 'AFFILIATE',
  Leader = 'LEADER',
}

export enum TradingType {
  Netting = 'NETTING',
  Hedging = 'HEDGING',
}

export enum WalletStatus {
  Active = 'ACTIVE',
  Disabled = 'DISABLED',
}

export enum MessageType {
  Push = 'PUSH',
  Message = 'MESSAGE',
}

export enum MessageStatus {
  Sent = 'SENT',
  Created = 'CREATED',
}

export interface ICustomerMessage {
  id: string;
  createdAt: Date;
  text: string;
  type: MessageType;
  status: MessageStatus;
}

export interface ICustomer {
  id: string | null;
  name: string | null;
  email: string | null;
  mobilenumber: string | null;
  depositTotal: number | null;
  percent: number | null;
  totalCoinsEarned: number | null;
  danglingCoins: number | null;
  country: string | null;
  countryName: string | null;
  status: 'active' | 'deactivated';
  availableContactMethods: Array<MessageType>;
  messages: Array<ICustomerMessage>;
  roles: Array<UserRole>;
  appInstalledAt: Date | null;
  totalCommission: number | null;
  tradingBalance: {
    balance: number | null;
    currency: string | null;
  };
  totalLogins: number | null;
  lastLoginDate: Date | null;
  notes: string;
  sendMessageErrors: Array<any> | null;
  isBookmarked?: boolean;
  hasFTD: boolean;
  source: string | null;
  wallets?: Array<IWallet>;
}

export interface ITransaction {
  id: string;
  createdAt: Date;
  amount: number;
  reason: string;
  sourceCustomer?: {
    id: string;
    name: string;
  };
}

export interface IBalanceWithCurrency {
  balance: number;
  currency: string;
}

export enum CommissionType {
  CPA = 'CPA',
  VOLUME = 'VOLUME',
  PROFIT_SHARE = 'PROFIT_SHARE',
}

export enum ActionType {
  FTD = 'FTD',
  Trade = 'Trade',
}

export interface ICommissionFiltersDTO {
  statuses: Array<string>;
}

export interface IAffiliateWallet {
  id: number;
  currency: string;
  type: string;
  status: string;
  isDemo: boolean;
  createdAt: string;
  tradingType: string;
  balance: string;
  credit: string;
  equity: string;
}

export interface IAffiliateTransaction {
  id: string;
  type: string;
  status: string;
  method: string;
  provider: string;
  providerRef: string;
  customer?: {
    id: string;
    name: string;
    kycStatus: string;
    country: string;
  };
  netAmountInUSD: number | null;
  creditedAt: string | null;
  createdAt: string;
  comment: string | null;
  amount: number;
  currency: string;
  adminId: string | null;
  walletAddress: string | null;
  wallet: number;
  ipAddress: string | null;
  withdrawalReview?: {
    reviewerId: string;
    reviewerIp: string;
    reviewedAt: string;
    status: string;
  } | null;
  affiliateCommission?: {
    introducerId: string;
    referralId: string;
    commissionType: string;
    actionType: string;
    actionDetails: string;
    referralName?: string;
  };
}

export interface IAffiliateWalletWithTransactions {
  wallet: IAffiliateWallet;
  transactions: IAffiliateTransaction[];
}
